import {
  Required,
  DataValidator,
  transformKeys,
  IsNumber,
} from "@/utils/type-vaildator";
import api, { apiV2 } from "./api";

interface ActorNameSuffixId {
  suffix_id: boolean,
}

class ActorRenameData {
  @Required("suffixId cannot be empty")
  @IsNumber("suffixId must be a number")
  suffixId: number;
}

const transformAndValidateData = (
  response: ActorNameSuffixId
): ActorRenameData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, ActorRenameData);
  } catch (error) {
    console.error("suffixId data validation failed:", error.message);
    throw error;
  }
};

/** 获取演员次数 */
export const actorNameSuffixId = async ({ userId }: { userId?: string }) => {
  const res = await apiV2.get<ActorNameSuffixId>('/users/actor-name-suffix-id', {
    user_id: userId,
  });
  const data = transformAndValidateData(res.data);
  return data;
}